export const SET_STATIC_CONFIGURATION = "setStaticConfiguration"
